<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title" *ngIf="inner_Funds.id==0">فرم ثبت اطلاعات عنوان هزینه</h5>
      <h5 class="card-title" *ngIf="inner_Funds.id>0">فرم ویرایش عنوان هزینه</h5>
      <form [formGroup]="FormFunds" (submit)="SubmitFormFunds()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">عنوان</label>
            <input formControlName="Title" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">عنوان را وارد نمائید.</small>
          </div>
        </div>
        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing && inner_Funds.id==0" type="submit" [disabled]="!FormFunds.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
        <button *ngIf="!InProccessing && inner_Funds.id>0" type="submit" [disabled]="!FormFunds.valid" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-edit"></i> ویرایش اطلاعات </button>

      </form>
  </div>
</div>

